import { SelectOption } from '@mui/base';
import { Type } from 'class-transformer';
import { CASTOption } from 'components/shared/CASTForm/common/types';
import { Nullable } from '@cast/leadcast-types';

const orderStatuses = [
  'ORDER_REQUESTED',
  'ORDER_REJECTED',
  'ORDER_PLACED',
  'KIT_SHIPPED',
  'KIT_DELIVERED',
  'SAMPLE_RETURNED',
  'SAMPLE_DELIVERED',
  'SAMPLE_REJECTED',
  'SAMPLE_ANALYZED',
  'COMPLETE',
  'ERROR',
  'CANCELLED',
] as const;

export type OrderStatus = (typeof orderStatuses)[number];

type OrderStatusDisplay = {
  [K in OrderStatus]: string;
};

const orderStatusDisplay: OrderStatusDisplay = {
  ORDER_REQUESTED: 'Order Requested',
  ORDER_REJECTED: 'Order Rejected',
  ORDER_PLACED: 'Order Placed',
  KIT_SHIPPED: 'Kit Shipped',
  KIT_DELIVERED: 'Kit Delivered',
  SAMPLE_RETURNED: 'Sample Returned',
  SAMPLE_DELIVERED: 'Sample Delivered',
  SAMPLE_REJECTED: 'Sample Rejected',
  SAMPLE_ANALYZED: 'Sample Analyzed',
  COMPLETE: 'Complete',
  ERROR: 'Error',
  CANCELLED: 'Cancelled',
};

export const orderStatusOptions: CASTOption<OrderStatus, string>[] = orderStatuses.map((os) => ({
  value: os,
  label: orderStatusDisplay[os],
}));

export interface SampleOrderStatusV2 {
  id: string;
  timestamp: Date;
  statusCode: OrderStatus;
  status: string;
  comment: Nullable<string>;
}

export class SampleOrderStatusV2 {
  @Type(() => Date)
  timestamp: Date;

  static lookupOrderStatusDisplay(status: OrderStatus): string {
    return orderStatusDisplay[status];
  }
}
